import createValidador from '../../hooks/createValidador'

const MAXIMO_DESCUENTO = 99

export const getEsquema = () => {
  const { Validador } = createValidador()

  return {
    titulo: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar el título de tu publicación!
              <br />
              Asegúrate de tener un buen título así el comprador podrá encontrar
              rápidamente tu producto.
            </>
          )
        })
      }),
    descripcion: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar la descripción del producto! <br /> Asegúrate
              de tener una buena descripción así el comprador sabrá exactamente qué está
              comprando.
            </>
          )
        })
      }),
    etiquetas: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar las etiquetas de búsqueda de tu publicación
            </>
          )
        })
      }),
    desde: Validador.Kernel.date()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la &quot;Fecha Desde&quot;</>
        })
      }),
    hasta: Validador.Kernel.date()
      .min(Validador.Kernel.ref('desde'))
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la &quot;Fecha Hasta&quot;</>,
          'date.min': (
            <>
              Ups, &quot;Fecha Hasta&quot; debe ser mayor o igual a &quot;Fecha
              Desde&quot;
            </>
          )
        })
      }),
    precioUnitario: Validador.Kernel.number()
      .empty(0)
      .required()
      .min(1)
      .error((e) => {
        return Validador.mensaje(e, {
          'number.min': <>Ups, el Precio no puede ser 0</>,
          'any.required': <>Ups, el Precio no puede ser 0</>
        })
      }),
    porcDcto: Validador.Kernel.number()
      .min(0)
      .max(MAXIMO_DESCUENTO)
      .error((e) => {
        return Validador.mensaje(e, {
          'number.max': <>Ups, el &quot;Porcentaje de descuento&quot; es incorrecto</>
        })
      }),
    mediosPagos: Validador.Kernel.array()
      .min(1)
      .error((e) => {
        return Validador.mensaje(e, {
          'array.min': <>Ups, debes seleccionar al menos una condición de pago</>
        })
      }),
    mediosEnvios: Validador.Kernel.array()
      .min(1)
      .error((e) => {
        return Validador.mensaje(e, {
          'array.min': <>Ups, debes seleccionar al menos un medio de envío</>
        })
      })
  }
}
